import React, { useContext } from 'react';

import { LocaleContext } from 'app/containers/LocaleProvider';
import { ConfigContext } from '../../ConfigProvider';

import Checkout from '../../Checkout';
import BasketDishes from '../../BasketDishes';
import { OrderDetailsFooter } from '../components/OrderDetailsFooter';

// TODO: декомпозировать стили
import '../../Order/order.scss';


const locales = {
    ru: {
        title: 'Оформить заказ',
    },
    en: {
        title: 'Order',
    },
};


export function OrderDetailsForm(props) {
    const {
        sendLeadAndTrack,
        setInitialCheckoutPhone,
        setHasInvoice,

        basketDishes,
        buttonsDisabled,
        hasReadyToEatContradiction,
        onLocationChange,
    } = props;

    const { locale } = useContext(LocaleContext);
    const { paymentWidgetType, pageId } = useContext(ConfigContext);

    return (
        <>
            <p styleName={`ny__order-content__title text-container ${pageId}`}>
                {locales[locale].title}
            </p>
            <div styleName="ny__order-content">
                <div styleName="ny__order-content__wrapper">
                    <Checkout
                        onPhoneEntered={sendLeadAndTrack}
                        onPhoneInitialized={setInitialCheckoutPhone}
                        onInvoiceCreated={setHasInvoice}
                        hasReadyToEatContradiction={hasReadyToEatContradiction}
                        onLocationChange={onLocationChange}
                    />
                    {basketDishes.length > 0 && (
                        <BasketDishes
                            hasTopIndent
                            dishes={basketDishes}
                            buttonsDisabled={buttonsDisabled}
                        />
                    )}
                </div>
            </div>
            <OrderDetailsFooter paymentWidgetType={paymentWidgetType} />
        </>
    );
}
